// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Redirect from deprecated singular route to plural route with params.
 */
export const Route = createFileRoute('/_app/purchase-order/$purchaseOrderKey')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/purchase-orders/$purchaseOrderKey',
      params: { purchaseOrderKey: params.purchaseOrderKey },
    });
  },
});
